export default __webpack_public_path__ + "static/media/super-ca-mobile.379dc7e2.jpg";